import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ChevronUpIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const ChevronUpIcon: React.FC<ChevronUpIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-chevron-up">
    <path
      d="M12 30 L25 18 L38 30"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default ChevronUpIcon;
